function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "140.173%",
  y1: "-32.113%",
  x2: "11.736%",
  y2: "90.735%",
  id: "cli-color_svg__a"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF",
  stopOpacity: 0,
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00FF12",
  offset: "12.833%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#08C466",
  offset: "100%"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "url(#cli-color_svg__a)",
  cx: 57,
  cy: 57,
  r: 57
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.923 75.812l-6.394-6.396 12.788-12.788L25.529 43.84l6.394-6.395 19.183 19.183-19.183 19.184zm54.641-1.164H57.5v-8.574h29.064v8.574z",
  fill: "#FFF",
  fillRule: "nonzero"
}));

var SvgCliColor = function SvgCliColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTE0cHgiIGhlaWdodD0iMTE0cHgiIHZpZXdCb3g9IjAgMCAxMTQgMTE0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPHRpdGxlPmNsaS5zdmc8L3RpdGxlPgogICAgPGRlZnM+CiAgICAgICAgPGxpbmVhckdyYWRpZW50IHgxPSIxNDAuMTcyNjk3JSIgeTE9Ii0zMi4xMTM0ODY4JSIgeDI9IjExLjczNTg4MjclIiB5Mj0iOTAuNzM0NjQ5MSUiIGlkPSJsaW5lYXJHcmFkaWVudC0xIj4KICAgICAgICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iI0ZGRkZGRiIgc3RvcC1vcGFjaXR5PSIwIiBvZmZzZXQ9IjAlIj48L3N0b3A+CiAgICAgICAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiMwMEZGMTIiIG9mZnNldD0iMTIuODMyOTg0MyUiPjwvc3RvcD4KICAgICAgICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iIzA4QzQ2NiIgb2Zmc2V0PSIxMDAlIj48L3N0b3A+CiAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgIDwvZGVmcz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJGbG93LUNMSSI+CiAgICAgICAgICAgIDxjaXJjbGUgaWQ9IkNvbG9yIiBmaWxsPSJ1cmwoI2xpbmVhckdyYWRpZW50LTEpIiBjeD0iNTciIGN5PSI1NyIgcj0iNTciPjwvY2lyY2xlPgogICAgICAgICAgICA8ZyBpZD0ibm91bl9Db21tYW5kLUxpbmVfMzkxMDgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI1LjAwMDAwMCwgMzcuMDAwMDAwKSIgZmlsbD0iI0ZGRkZGRiIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik02LjkyMywzOC44MTIgTDAuNTI5LDMyLjQxNiBMMTMuMzE3LDE5LjYyOCBMMC41MjksNi44NCBMNi45MjMsMC40NDUgTDI2LjEwNiwxOS42MjggTDYuOTIzLDM4LjgxMiBaIE02MS41NjQsMzcuNjQ4IEwzMi41LDM3LjY0OCBMMzIuNSwyOS4wNzQgTDYxLjU2NCwyOS4wNzQgTDYxLjU2NCwzNy42NDggWiIgaWQ9IlNoYXBlIj48L3BhdGg+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==";
export { SvgCliColor as ReactComponent };